
define(['jquery'], function($) {
  var Popover;
  return Popover = (function() {

    function Popover(element, position, settings) {
      this.element = element;
      this.position = position;
      this.settings = settings != null ? settings : {};
    }

    Popover.prototype.template = function() {
      var arrowTemplates, template;
      arrowTemplates = {
        top: '<div class="arrow-wrapper"><div class="ss-dropdown"></div></div>',
        bottom: '<div class="arrow-wrapper"><div class="ss-gizmo ss-directup"></div></div>'
      };
      template = '<div class="popover action-popover">{bottom}<div class="popover-inner"><div class="popover-content"><p></p></div></div>{top}</div>';
      template = template.replace("{" + this.position + "}", arrowTemplates[this.position]);
      template = template.replace('{bottom}', '');
      template = template.replace('{top}', '');
      return template;
    };

    Popover.prototype.build = function(content) {
      this.content = content;
      this.attachContent = this.content instanceof $;
      return this.element.popover({
        html: true,
        trigger: 'manual',
        placement: 'in ' + this.position,
        appendTo: this.element,
        content: !this.attachContent ? this.content : '&nbsp;',
        template: this.template()
      });
    };

    Popover.prototype.show = function() {
      var left;
      this.element.popover('show');
      if (this.attachContent) {
        this.element.find('.popover-content > p').replaceWith(this.content);
      }
      this.popover = this.element.find('.popover');
      if (this.settings.classes) {
        this.popover.addClass(this.settings.classes);
      }
      if (this.settings.alignToRight) {
        return this.alignToRight(this.settings.alignDiff);
      } else if (this.settings.alignDiff) {
        left = this.popover.css('left');
        return this.popover.css('left', parseInt(left) + this.settings.alignDiff);
      }
    };

    Popover.prototype.alignToRight = function(diff) {
      if (diff == null) {
        diff = -10;
      }
      this.popover.css({
        'right': diff,
        'left': 'auto'
      });
      return this.popover.find('.arrow-wrapper').css({
        'right': 0,
        'left': 'auto'
      });
    };

    Popover.prototype.alignToLeft = function(diff) {
      if (diff == null) {
        diff = -10;
      }
      this.popover.css({
        'right': 'auto',
        'left': diff
      });
      return this.popover.find('.arrow-wrapper').css({
        'right': 'auto',
        'left': 0
      });
    };

    Popover.prototype.hide = function() {
      this.element.popover('destroy');
      return this.element.removeClass('opened');
    };

    Popover.prototype.action = function(event, action) {
      var popover;
      popover = this.element.find('.popover');
      if ((event != null) && (popover.has(event.target).length || popover[0] === event.target)) {
        return;
      }
      if (!this.element.hasClass('opened')) {
        if (typeof action === "function") {
          action();
        }
      } else {
        this.element.popover('destroy');
      }
      return this.element.toggleClass('opened');
    };

    return Popover;

  })();
});
